function createCommunicate(value, remainingFieldsToCommunicateMap) {
  let category = '';
  let fieldText = '';
  Object.keys(remainingFieldsToCommunicateMap)
    .forEach(
      (fieldCategory) => {
        if (value in remainingFieldsToCommunicateMap[fieldCategory]) {
          category = fieldCategory;
          fieldText = remainingFieldsToCommunicateMap[fieldCategory][value];
        }
      },
    );
  return {
    category,
    fieldText,
  };
}

export const missingFields = {
  methods: {
    processMissingFields(fieldsToProcess, remainingFieldsToCommunicateMap) {
      const processedFields = {};
      Object.values(fieldsToProcess)
        .forEach(
          (value) => {
            const userCommunicate = createCommunicate(value, remainingFieldsToCommunicateMap);

            if (!processedFields[userCommunicate.category]) {
              processedFields[userCommunicate.category] = [];
            }

            processedFields[userCommunicate.category].push({
              text: userCommunicate.fieldText,
              value,
            });
          },
        );

      return processedFields;
    },
  },

};
